import VIEWMODEL_PRESETS from './VIEWMODEL_PRESETS.json'

export const VIEWMODEL_GALLERY = VIEWMODEL_PRESETS;
